import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import heroImg from '../../assets/furniture/img4.jpg'; // Just picking a high quality image

const Hero = () => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 500], [0, 150]);

  return (
    <section className="relative h-screen w-full overflow-hidden bg-charcoal flex items-center justify-center">
      {/* Background Image with Parallax */}
      <motion.div 
        style={{ y, scale: 1.05 }}
        className="absolute inset-0 z-0"
      >
        <div className="absolute inset-0 bg-charcoal/40 mix-blend-multiply z-10" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/20 via-transparent to-charcoal z-10" />
        <img 
          src={heroImg} 
          alt="Antique Furniture Craftsmanship" 
          className="w-full h-full object-cover"
        />
      </motion.div>

      {/* Content */}
      <div className="relative z-20 text-center px-6 max-w-5xl mx-auto mt-16 md:mt-20">
        {/* <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <p className="text-brass tracking-[0.2em] md:tracking-[0.3em] uppercase text-xs md:text-sm font-semibold mb-4 md:mb-6">
            Est. 2024 • 5 Generations of Artisans
          </p>
        </motion.div> */}

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4 }}
          className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl text-linen font-serif mb-6 md:mb-8 drop-shadow-lg leading-tight"
        >
          Timeless Craft, <br />
          <span className="italic text-brass font-serif">Curated Living.</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="text-linen/80 text-base md:text-xl font-sans max-w-2xl mx-auto mb-10 md:mb-12 font-light"
        >
          Discover handcrafted, custom antique furniture inspired by Colonial and Chettinad heritage. Built today, cherished forever.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          <a href="/furnitures" className="inline-block px-8 md:px-10 py-3.5 md:py-4 border border-brass text-brass hover:bg-brass hover:text-charcoal transition-all duration-300 tracking-widest uppercase text-xs">
            Explore Collections
          </a>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-3"
      >
        <span className="text-brass/60 text-xs tracking-widest uppercase">Scroll</span>
        <motion.div 
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
          className="h-10 w-[1px] bg-gradient-to-b from-brass/60 to-transparent"
        />
      </motion.div>
    </section>
  );
};

export default Hero;
